export const RIGHT_ALIGNED = 'RIGHT_ALIGNED';
export const LEFT_ALIGNED = 'LEFT_ALIGNED';